// Accordion Menu
Array.from(document.querySelectorAll('.accordion')).forEach(function(accordion) {

    let header = accordion.querySelector('.accordion-header');
    let wrapper = accordion.parentElement;

    header.onclick = function() {

        let activeAccordion = wrapper.querySelector('.accordion--active');
        if (activeAccordion && activeAccordion !== accordion) {
            activeAccordion.classList.remove('accordion--active');
        } 

        accordion.classList.toggle('accordion--active');

        return false;
    }


}); 